export default "__VITE_ASSET__Cv98mADm__"